export enum EntrySelectedState {
  NONE_SELECTED = 0,
  BEFORE_SELECTED = 1,
  AFTER_SELECTED = 2,
}

export const LOCAL_STORAGE_COMPARE_DONE = 'comparePreviouslyCompletedStatus';
